import React, { useState } from "react";
import "./Navbar.css";
import logo from "../assets/LogoAF.jpg";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="nav">
      <div className="logo">
        <img src={logo} alt="AF Dienstleistungen Logo" />
      </div>

      <div className={`links ${open ? "active" : ""}`}>
        <a href="#services">Dienstleistungen</a>
        <a href="#about">Über uns</a>
        <a href="#contact">Kontakt</a>
      </div>

      <div className="burger" onClick={() => setOpen(!open)}>☰</div>
    </nav>
  );
}